var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Finalizar atención")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("div", { staticClass: "student-participation" }, [
            _c("h4", { staticClass: "section-title" }, [
              _vm._v("¿EL ESTUDIANTE PARTICIPÓ?")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons has-addons" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  class: _vm.participationButtonClass(
                    "yes",
                    _vm.didParticipate
                  ),
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.didParticipate = true
                    }
                  }
                },
                [_vm._v("\n          sí\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  class: _vm.participationButtonClass("no", _vm.didParticipate),
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.didParticipate = false
                    }
                  }
                },
                [_vm._v("\n          no\n        ")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.didParticipate === true
            ? _c("div", [
                _c("div", { staticClass: "attention-details" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("RESULTADO")
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.result,
                        expression: "result"
                      }
                    ],
                    attrs: { placeholder: "Especificar detalles..." },
                    domProps: { value: _vm.result },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.result = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-private-comments-checkbox" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasPrivateComments,
                          expression: "hasPrivateComments"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        disabled: !_vm.canWritePrivateComments
                      },
                      domProps: {
                        checked: Array.isArray(_vm.hasPrivateComments)
                          ? _vm._i(_vm.hasPrivateComments, null) > -1
                          : _vm.hasPrivateComments
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.hasPrivateComments,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.hasPrivateComments = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.hasPrivateComments = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.hasPrivateComments = $$c
                          }
                        }
                      }
                    }),
                    _vm._v("\n          Confidencial\n        ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "attention-emotion" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("SITUACIÓN DEL ESTUDIANTE")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emotion-picker" }, [
                    _c(
                      "button",
                      {
                        staticClass: "emotion",
                        class: _vm.emotionClass("YAY"),
                        on: {
                          click: function($event) {
                            _vm.selectedEmotion = "YAY"
                          }
                        }
                      },
                      [_vm._v("\n            :)\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "emotion",
                        class: _vm.emotionClass("MEH"),
                        on: {
                          click: function($event) {
                            _vm.selectedEmotion = "MEH"
                          }
                        }
                      },
                      [_vm._v("\n            :|\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "emotion",
                        class: _vm.emotionClass("SAD"),
                        on: {
                          click: function($event) {
                            _vm.selectedEmotion = "SAD"
                          }
                        }
                      },
                      [_vm._v("\n            :(\n          ")]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.didParticipate === false
            ? _c("div", [
                _c("div", { staticClass: "student-participation" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v(
                      "¿EL ESTUDIANTE TODAVÍA SE ENCUENTRA EN LA INSTITUCIÓN?"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons has-addons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        class: _vm.participationButtonClass(
                          "no",
                          _vm.didAbandon
                        ),
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.didAbandon = false
                          }
                        }
                      },
                      [_vm._v("\n            sí\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        class: _vm.participationButtonClass(
                          "yes",
                          _vm.didAbandon
                        ),
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.didAbandon = true
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            no, el estudiante ya desertó\n          "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "attention-details" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("RESULTADO")
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.result,
                        expression: "result"
                      }
                    ],
                    attrs: { placeholder: "Especificar detalles..." },
                    domProps: { value: _vm.result },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.result = $event.target.value
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.didParticipate !== null
            ? _c("div", { staticClass: "student-participation" }, [
                _c("h4", { staticClass: "section-title" }, [
                  _vm._v("¿DESEA NOTIFICAR AL ESTUDIANTE POR CORREO?")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons has-addons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: _vm.participationButtonClass(
                        "yes",
                        _vm.shouldNotifyStudent
                      ),
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.shouldNotifyStudent = true
                        }
                      }
                    },
                    [_vm._v("\n          sí\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      class: _vm.participationButtonClass(
                        "no",
                        _vm.shouldNotifyStudent
                      ),
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.shouldNotifyStudent = false
                        }
                      }
                    },
                    [_vm._v("\n          no\n        ")]
                  )
                ]),
                _vm._v(" "),
                _vm.shouldNotifyStudent
                  ? _c("div", { staticClass: "attention-notify" }, [
                      _c("h4", { staticClass: "section-title" }, [
                        _vm._v("Mensaje para el estudiante")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.messageForStudent,
                            expression: "messageForStudent"
                          }
                        ],
                        attrs: {
                          placeholder:
                            "Agregar comentario alternativo para el estudiante..."
                        },
                        domProps: { value: _vm.messageForStudent },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.messageForStudent = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.shouldNotifyStudent
                  ? _c("div", [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.includeResultsInEmail,
                              expression: "includeResultsInEmail"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.hasPrivateComments
                          },
                          domProps: {
                            checked: Array.isArray(_vm.includeResultsInEmail)
                              ? _vm._i(_vm.includeResultsInEmail, null) > -1
                              : _vm.includeResultsInEmail
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.includeResultsInEmail,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.includeResultsInEmail = $$a.concat([
                                      $$v
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.includeResultsInEmail = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.includeResultsInEmail = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          "\n          Incluir resultados de la atención en el correo\n        "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.didParticipate != null
            ? _c("derivation-list", {
                attrs: { derivations: _vm.derivations },
                on: {
                  "update:derivations": function($event) {
                    _vm.derivations = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("p", { staticClass: "error-message is-danger" }, [
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary finish",
            class: { "is-loading": _vm.loading },
            attrs: { disabled: !_vm.isValid },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Agregar\n    ")]
        ),
        _vm._v("\n     \n    "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.attentions")
              }
            }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }